const ConnectionFeatures = () => {
	return (
		<>
			<p className="omnisend-paragraph-14">
				Connect Omnisend plugin to Wordpress to:
			</p>
			<div className="omnisend-spacing-mt-4">
				<ul className="omnisend-bullet-list">
					<li>
						<span>
							Automatically import all your WordPress users to
							Omnisend
						</span>
					</li>
					<li>
						<span> Collect subscribers through Forms </span>
					</li>
					<li>
						<span> Segment and target your customers </span>
					</li>
					<li>
						<span> Set up behavior-based automations </span>
					</li>
				</ul>
			</div>
		</>
	);
};

export default ConnectionFeatures;
